import load from './load.vue'
const tigerLoad = {
  install (Vue, options) {
    if (typeof window !== 'undefined' && window.Vue) {
      Vue = window.Vue
    }
    Vue.component('tiger-load', load)
  }
}
export default tigerLoad


// WEBPACK FOOTER //
// ./src/lib/index.js